import React, { useEffect, useState } from "react";
import "../assets/css/tickets.css";
import "../assets/css/todo.css";
import axios from "axios";
import Loader from "../components/Loader";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import { FaFilter, FaTimes } from "react-icons/fa";
import temp from "../assets/images/user-icon.jpg";
import newlogo from "../assets/images/newlogo.webp";

const Tickets = () => {
  const dispatch = useDispatch();
  const { url, user } = useSelector((state) => state.user);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(false);
  const getTickets = async () => {
    const token = await dispatch(getToken());
    setLoading(true);
    try {
      const res = await axios.get(
        `${url}/proxy?url=https://desk.zoho.in/api/v1/tickets/search?limit=100&email=${user.Email}`,
        {
          headers: { Authorization: `Zoho-oauthtoken ${token.payload}` },
        },
      );
      if (res.status === 200) {
        const data = res.data.data;
        data.forEach((item) => {
          for (let i in item) {
            if (item[i] === null) {
              item[i] = "";
            }
            if (i === "createdTime") {
              const date = new Date(item[i]);
              const formattedTime = date.toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              });
              item[i] = formattedTime;
            }
            if (i === "closedTime") {
              if (!item[i]) {
                item[i] = "-";
              } else {
                const date = new Date(item[i]);
                const formattedTime = date.toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                });
                item[i] = formattedTime;
              }
            }
          }
        });
        setData1(data);
        setData2(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user.Email !== null) {
      getTickets();
    }
  }, [user]);
  //
  const [searchInput, setSearchInput] = useState("");
  const filterData = () => {
    const filtered = data1.filter((item) => {
      const ticket = item?.ticketNumber
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());

      const subjectMatch = item?.subject
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());

      const statusMatch =
        filterInputs.status === "" ||
        item?.statusType?.toLowerCase() === filterInputs.status.toLowerCase();

      const depMatch =
        filterInputs.department === "" ||
        item?.department?.name?.toLowerCase() ===
          filterInputs.department.toLowerCase();

      return (ticket || subjectMatch) && statusMatch && depMatch;
    });
    setData2(filtered);
    setModalVisible(false);
  };
  useEffect(() => {
    filterData();
  }, [searchInput, data1]);
  const [filterInputs, setFilterInputs] = useState({
    status: "",
    department: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const openModal = () => {
    setModalVisible(true);
  };
  const closeModal = () => {
    setModalVisible(false);
  };
  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
    setFilterInputs({
      ...filterInputs,
      [name]: value,
    });
  };
  const resetSearchFilter = () => {
    setSearchInput("");
    setFilterInputs({
      status: "",
      department: "",
    });
    setModalVisible(false);
    setData2(data1);
  };
  //
  const [messageModalVisible, setMessageModalVisible] = useState(false);
  const [messageID, setMessageID] = useState("");
  const [chats, setChats] = useState([]);
  const callMessageAPI = async (id) => {
    setMessageID(id);
    const token = await dispatch(getToken());
    const res = await axios.get(
      `${url}/proxy?url=https://desk.zoho.in/api/v1/tickets/${id}/threads`,
      {
        headers: { Authorization: `Zoho-oauthtoken ${token.payload}` },
      },
    );
    const details = res.data.data;
    details.forEach((item, index) => {
      if (item.fromEmailAddress.toLowerCase().includes("zohodesk.in")) {
        item.ourMessage = true;
      } else {
        item.ourMessage = false;
      }
    });
    setChats(details);
    setMessageModalVisible(true);
  };
  return (
    <>
      <div className="payments-container">
        <div className="d-flex justify-content-between gap-2 flex-sm-row flex-column">
          <Title title="Tickets" />
          <div className="filter-flex">
            <input
              type="text"
              className="input"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button className="button" onClick={openModal}>
              <FaFilter />
            </button>
          </div>
        </div>
        <hr />
        <div className="project-table-overflow">
          {loading === true ? (
            <Loader />
          ) : (
            <>
              {data2.length === 0 ? (
                <p className="text-center">No data found</p>
              ) : (
                <table className="project-table tickets-table">
                  <thead>
                    <tr>
                      <th>Sr</th>
                      <th>Ticket Number</th>
                      <th>Status</th>
                      <th>Subject</th>
                      <th>Department</th>
                      <th>View message</th>
                      <th>Created Time</th>
                      <th>Closed Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.ticketNumber || "-"}</td>
                          <td>{item.statusType || "-"}</td>
                          <td>
                            <p className="ticket-clamp">
                              {item.subject || "-"}
                            </p>
                          </td>
                          <td>{item.department?.name || "-"}</td>
                          <td>
                            <button
                              className="button w-100"
                              onClick={() => callMessageAPI(item.id)}
                            >
                              View Message
                            </button>
                          </td>
                          <td>
                            <p className="ticket-clamp">
                              {item.createdTime || "-"}
                            </p>
                          </td>
                          <td>
                            <p className="ticket-clamp">
                              {item.closedTime === null ? "-" : item.closedTime}
                            </p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </div>

      <div
        className={`modal-background ${modalVisible ? "active" : ""}`}
        style={{ zIndex: "100" }}
      >
        <div className="modal-container">
          <div className="d-flex align-items-end justify-content-between">
            <h2>Filter</h2>
            <button className="red-button" onClick={closeModal}>
              <FaTimes />
            </button>
          </div>
          {/*  */}
          <hr />
          <div>
            <div className="mt-4">
              <p className="mb-2">Ticket status</p>
              <select
                className="input"
                name="status"
                value={filterInputs.status}
                onChange={handleFilterInputs}
              >
                <option value="">select</option>
                <option value="Open">Open</option>
                <option value="Closed">Closed</option>
              </select>
            </div>
            <div className="mt-4">
              <p className="mb-2">Department</p>
              <select
                className="input"
                name="department"
                value={filterInputs.department}
                onChange={handleFilterInputs}
              >
                <option value="">select</option>
                <option value="Legal Team">Legal Team</option>
                <option value="Customer service department">
                  Customer service department
                </option>
              </select>
            </div>
          </div>
          <div className="d-flex align-content-center justify-content-end gap-2 mt-4">
            <button
              className="red-button"
              onClick={resetSearchFilter}
              style={{ width: "90px" }}
            >
              Reset
            </button>
            <button
              className="button"
              onClick={filterData}
              style={{ width: "90px" }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>

      <div
        className={`modal-background ${messageModalVisible ? "active" : ""}`}
      >
        <div className="modal-container message-modal-container">
          <div className="d-flex align-items-center justify-content-between flex-wrap mb-3">
            <p className="fw-bold">#{messageID}</p>
            <button
              className="button"
              onClick={() => setMessageModalVisible(false)}
            >
              <FaTimes />
            </button>
          </div>
          {chats.map((item, index) => {
            return (
              <div
                className={`message-flex ${item.ourMessage === true ? "reverse-message" : ""} ${index === chats.length - 1 ? "" : "mb-3"}`}
                key={index}
              >
                <div className="message-pic">
                  <img
                    src={item.ourMessage === false ? newlogo : temp}
                    alt=""
                  />
                </div>
                <div
                  className={`message-box ${item.ourMessage === false ? "our-message" : ""}`}
                >
                  <p>{item.summary}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Tickets;
